// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"98c88cf3","103":"472bf714","391":"7f31fac4","488":"5e7ff1b9"}[chunkId] + ".chunk.js";
};